import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import gfm from "@bytemd/plugin-gfm";
import highlight from "@bytemd/plugin-highlight-ssr";
import math from "@bytemd/plugin-math-ssr";
import { Editor } from "@bytemd/vue-next";


/**
 定义组件属性类型
 */
interface Props {
  value: string;
  mode?: string;
  handleChange: (v: string) => void;
}

/**
 给组件指定初始值
 */

export default /*@__PURE__*/_defineComponent({
  __name: 'MdEditor',
  props: {
    value: { default: () => "" },
    mode: { default: () => "split" },
    handleChange: { type: Function, default: (v: string) => {
    console.log(v);
  } }
  },
  setup(__props: any) {

const props = __props;

const plugins = [
  gfm(),
  highlight(),
  math(),
  // Add more plugins here
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Editor), {
    mode: _ctx.mode,
    plugins: plugins,
    value: _ctx.value,
    onChange: _ctx.handleChange
  }, null, 8, ["mode", "value", "onChange"]))
}
}

})